<template>
  <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M59.5 30C59.5 46.2924 46.2924 59.5 30 59.5C13.7076 59.5 0.5 46.2924 0.5 30C0.5 13.7076 13.7076 0.5 30 0.5C46.2924 0.5 59.5 13.7076 59.5 30Z"
      fill="#F9F9F9"
      stroke="#E9E9E9"
    />
    <path
      d="M37.0904 16.1055H19.0808C18.2746 16.1055 17.639 16.7618 17.6648 17.568L18.6002 44.7401C18.626 45.5462 19.3082 46.2025 20.1143 46.2025H39.664C40.4701 46.2025 41.1523 45.5462 41.1781 44.7401L41.9998 20.679C41.9998 20.679 39.5038 19.1545 38.9147 18.6067L37.0904 16.1003V16.1055Z"
      fill="#222222"
    />
    <path
      d="M27.6857 22.1551H21.8771C21.5929 22.1551 21.3604 21.9226 21.3604 21.6384C21.3604 21.3541 21.5929 21.1216 21.8771 21.1216H27.6857C27.9699 21.1216 28.2025 21.3541 28.2025 21.6384C28.2025 21.9226 27.9699 22.1551 27.6857 22.1551Z"
      fill="white"
    />
    <path
      d="M37.9095 26.5528H21.8791C21.5949 26.5528 21.3623 26.3203 21.3623 26.0361C21.3623 25.7518 21.5949 25.5193 21.8791 25.5193H37.9095C38.1937 25.5193 38.4262 25.7518 38.4262 26.0361C38.4262 26.3203 38.1937 26.5528 37.9095 26.5528Z"
      fill="white"
    />
    <path
      d="M37.9095 29.2245H21.8791C21.5949 29.2245 21.3623 28.9919 21.3623 28.7077C21.3623 28.4235 21.5949 28.1909 21.8791 28.1909H37.9095C38.1937 28.1909 38.4262 28.4235 38.4262 28.7077C38.4262 28.9919 38.1937 29.2245 37.9095 29.2245Z"
      fill="white"
    />
    <path
      d="M37.9095 31.8905H21.8791C21.5949 31.8905 21.3623 31.6579 21.3623 31.3737C21.3623 31.0895 21.5949 30.8569 21.8791 30.8569H37.9095C38.1937 30.8569 38.4262 31.0895 38.4262 31.3737C38.4262 31.6579 38.1937 31.8905 37.9095 31.8905Z"
      fill="white"
    />
    <path
      d="M37.9095 34.5621H21.8791C21.5949 34.5621 21.3623 34.3296 21.3623 34.0453C21.3623 33.7611 21.5949 33.5286 21.8791 33.5286H37.9095C38.1937 33.5286 38.4262 33.7611 38.4262 34.0453C38.4262 34.3296 38.1937 34.5621 37.9095 34.5621Z"
      fill="white"
    />
    <path
      d="M37.9095 37.2337H21.8791C21.5949 37.2337 21.3623 37.0012 21.3623 36.717C21.3623 36.4327 21.5949 36.2002 21.8791 36.2002H37.9095C38.1937 36.2002 38.4262 36.4327 38.4262 36.717C38.4262 37.0012 38.1937 37.2337 37.9095 37.2337Z"
      fill="white"
    />
    <path
      d="M37.9093 41.1959H32.1008C31.8165 41.1959 31.584 40.9634 31.584 40.6791C31.584 40.3949 31.8165 40.1624 32.1008 40.1624H37.9093C38.1935 40.1624 38.4261 40.3949 38.4261 40.6791C38.4261 40.9634 38.1935 41.1959 37.9093 41.1959Z"
      fill="white"
    />
    <path d="M37.0899 16.1272L36.9297 20.6852H41.9993" fill="#222222" />
  </svg>
</template>
